export const PLAYER_ADD_PLAYER = "player/add-player";
export const PLAYER_SET_ACTIVE = "player/set-active";
export const PLAYER_SET_PLAYERS = "player/set-players";
